<template>
  <span>{{ val }}</span>
</template>

<script setup lang="ts">
import type { PersonalizationVariable } from '~/sanity/types';
const { personalizeVariableBlock } = usePersonalization();

const props = defineProps<PersonalizationVariable>();

const val = personalizeVariableBlock(props);
</script>
